/** @jsxImportSource @emotion/react */
import React from 'react';

import { Box, Stack } from '@mui/material';
import { CustomButton, TextButton } from 'src/components';

import { ReferrerType } from 'src/constants';

export const SignInOptions: React.FC<{
  onOptionSelect: (option: ReferrerType) => void;
}> = ({ onOptionSelect }) => {
  return (
    <Stack mt={4} gap={4} alignItems="center">
      <Box>
        <CustomButton
          onClick={() => onOptionSelect(ReferrerType.EXTERNAL)}
          label="Continue"
        />
      </Box>
      <TextButton onClick={() => onOptionSelect(ReferrerType.INTERNAL)}>
        I'm from AgileEngine
      </TextButton>
    </Stack>
  );
};
